var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('el-container',[_c('el-header',[_c('top-nav')],1),_c('el-main',[_c('router-view')],1),_c('div',[_c('bottom-nav')],1)],1),(!_vm.isMobileEnd)?_c('back-top'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }